import { defineStore } from 'pinia'

interface wxShareState {
  entryUrl: string
  isWxConfigOk: boolean
}

export const useWxShareStore = defineStore({
  id: 'wxshare',
  state: (): wxShareState => ({
    entryUrl: '',
    isWxConfigOk: false,
  }),
  getters: {
    getEntryUrl: (state) => {
      return state.entryUrl as string
    },
  },
  actions: {
    setEntryUrl(url: string) {
      this.entryUrl = url
    },
    setIsWxConfigOk(val: boolean) {
      this.isWxConfigOk = val
    },
  },
})
